export class MenuItemPermission {
    path: string;
    permissionName: string;
}
